import { BodyMeasurementOverrideType, BodyMeasurementOverrideXMLType } from 'src/types/decorationSpecs';

/**
 * Converts a designer-entered body measurement override to/from the PascalCase JSON shape stored
 * in a scene revision's `metadata.bodyMeasurementOverride` field, mirroring
 * `garmentMarkers.ts`/`garmentPlacement.ts`. Scene-maker bookkeeping (not part of the shared
 * CIM/Dip XML schema), so it rides alongside the XML on the revision record rather than inside
 * it — see `BodyMeasurementOverrideType`'s own doc comment for why this isn't nested inside
 * `GarmentMarkersState` instead.
 */

export type BodyMeasurementOverrideState = { BodyMeasurementOverride: BodyMeasurementOverrideXMLType };

export function fromState(override: BodyMeasurementOverrideType): BodyMeasurementOverrideState {
    return {
        BodyMeasurementOverride: {
            Size: override.size,
            WidthMm: override.widthMm,
            LengthMm: override.lengthMm,
        },
    };
}

export function toState(override: BodyMeasurementOverrideXMLType): BodyMeasurementOverrideType {
    return {
        size: override.Size,
        widthMm: override.WidthMm,
        lengthMm: override.LengthMm,
    };
}
